// Same counseling desk as makerz.co.kr. Load only after a customer clicks 문의하기.
import "./happytalk.css";

const SDK_URL = "https://chat-static.happytalkio.com/sdk/happytalk.chat.v2.min.js";
const CONFIG = {
  dynamicScript: true,
  siteId: "1000427149",
  siteName: "주식회사 쓰리디메이커즈",
  categoryId: "202189",
  divisionId: "202190",
  partnerId: "2",
  shopId: "1",
  kakaoId: "@3dmakerz",
  // Override only this installation: the shared desk also exposes a Kakao launcher.
  // Keep it absent while the SDK switches from its button page to the chat window.
  options: {
    isKakaotalkPc: false,
    isKakaotalkMobile: false,
  },
};
let client;
let loading;
let opening;
let generation = 0;
let requested = false;
const readyListeners = new Set();

function loadClient() {
  if (client) return Promise.resolve(client);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.id = "happytalkSDK";
    script.async = true;
    script.src = SDK_URL;
    const fail = () => {
      clearTimeout(timer);
      script.onload = script.onerror = null;
      script.remove();
      loading = null;
      reject(new Error("Happytalk SDK unavailable"));
    };
    const timer = setTimeout(fail, 15000);
    script.onerror = fail;
    script.onload = () => {
      clearTimeout(timer);
      try {
        client = new window.Happytalk(CONFIG);
        client.event.on("happytalk:ready", () => readyListeners.forEach(fn => fn()));
        client.event.on("happytalk:open", () => {
          if (requested) document.documentElement.classList.add("cookistory-chat-open");
          else client.close();
        });
        client.event.on("happytalk:close", () => {
          requested = false;
          document.documentElement.classList.remove("cookistory-chat-open");
        });
        resolve(client);
      } catch (error) {
        fail();
      }
    };
    document.head.appendChild(script);
  });
  return loading;
}

function waitUntilReady(chat) {
  if (chat.htButtonLoaded) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const done = () => {
      clearTimeout(timer);
      readyListeners.delete(done);
      resolve();
    };
    const timer = setTimeout(() => {
      readyListeners.delete(done);
      reject(new Error("Happytalk connection timed out"));
    }, 15000);
    readyListeners.add(done);
  });
}

export function openHappytalk() {
  if (opening) return opening;
  const current = generation;
  const task = loadClient().then(async chat => {
    await waitUntilReady(chat);
    if (current === generation) {
      requested = true;
      chat.open();
    }
  }).finally(() => { if (opening === task) opening = null; });
  opening = task;
  return task;
}

export function closeHappytalk() {
  generation += 1;
  requested = false;
  opening = null;
  client?.close();
  document.documentElement.classList.remove("cookistory-chat-open");
}
